export const vibrate = (ms: number) => {
	navigator.vibrate?.(ms);
	window.AndroidInterface?.vibrate?.(ms);
};
